<template>
    <div class="Field__Component">
        <div><slot>פנייה מקצועית על שאלה {{value}}</slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value'],
};
</script>

<style scoped>

</style>
